/**
 * Created by superman on 17/2/16.
 * http配置
 */

import axios from 'axios'
import store from './store'
import * as types from './store/types'
import router from './router'

import config from '@/config'
import {
	Loading
} from 'element-ui';
import _ from 'lodash';
// axios 配置
//axios.defaults.timeout = 5000;
//axios.defaults.baseURL = config.apiHost;
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.transformRequest = [function (data) {
//     //数据序列化
//     return qs.stringify(data);
// }];


//loading对象
let loading;

//当前正在请求的数量
let needLoadingRequestCount = 0;

//显示loading
function showLoading(target) {
	// 但needLoadingRequestCount已经变成0.避免这种情况下会重新创建个loading
	if (needLoadingRequestCount === 0 && !loading) {
		loading = Loading.service({
			lock: true,
			customClass: "wobblebar-loader",
			background: 'rgba(0, 0,0, 0.5)',
			target: target || "body"
		});
	}
	needLoadingRequestCount++;
}

//隐藏loading
function hideLoading() {
	needLoadingRequestCount--;
	needLoadingRequestCount = Math.max(needLoadingRequestCount, 0); //做个保护
	if (needLoadingRequestCount === 0) {
		//关闭loading
		toHideLoading();
	}
}

//防抖：将 300ms 间隔内的关闭 loading 便合并为一次。防止连续请求时， loading闪烁的问题。
var toHideLoading = _.debounce(() => {
	loading.close();
	loading = null;
}, 300);

// http request 拦截器
axios.interceptors.request.use(
	config => {
		// 		if (config.method == "post") {
		// 			//config.data = JSON.stringify(config.data);
		// 			//config.data = qs.stringify(config.data);
		// 			//config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
		// 		}
		if (store.state.token) {
			config.headers.Authorization = `Bearer ${store.state.token}`;
		}
		//判断当前请求是否设置了不显示Loading
		if (config.headers.showLoading !== false) {
			showLoading(config.headers.loadingTarget);
		}
		return config;
	},
	err => {
		//判断当前请求是否设置了不显示Loading
		if (config.headers.showLoading !== false) {
			hideLoading();
		}
		return Promise.reject(err);
	});

// http response 拦截器
axios.interceptors.response.use(
	response => {
		
		if (response.headers['content-type'] == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
			return response.data;
		}
		if (response.config.headers.showLoading !== false) {
			hideLoading();
		}
		return response.data.result;
	},
	error => {
		if (error.config.headers.showLoading !== false) {
			hideLoading();
		}
		if (error.response) {
			let errorResponse = error.response;
			let errorResult = error.response.data.error;
		
			switch (errorResponse.status) {
				case 400:
					if (errorResult.validationErrors) {
						return {
							status: false,
							msg: errorResult.validationErrors[0].message
						};
					}
					break;
				case 401:
					// 401 清除token信息并跳转到登录页面
					store.commit(types.LOGOUT);
					router.replace({
						path: 'login',
						query: {
							redirect: router.currentRoute.fullPath
						}
					})
					if(errorResponse.data && errorResponse.data.error_description){
						return {
							status: false,
							msg: errorResponse.data.error_description
						};
					}
					return {
						status: false,
						msg: "登录超时，请重新登录！"
					};
				case 403:
					return {
						status: false,
						msg: "没有该权限！！"
					};
				case 500:
					if (errorResult.details) {
						return {
							status: false,
							msg: errorResult.details
						};
					}
			}
			return {
				status: false,
				msg: '出现异常'
			}; 
		}
	});

export default axios;
